module.exports = __webpack_public_path__ + "img/banner3.459b95eb.png";